import { Container, EventsContainer, EventsDivider, Title, Wrapper } from './Events.styles';
import { FC, useState } from 'react';

import { CreateEvent } from './CreateEvent';
import { Event } from './Event/';
import { FILTER_OPTIONS } from 'features/common/components/Filters/LocalFilter/constants';
import { FilterOptionType } from 'features/common/components/Filters/LocalFilter/types';
import { LazyLoader } from 'features/common/animations/LazyLoader';
import { LocalFilter } from 'features/common/components/Filters/LocalFilter';
import { Search } from 'features/common/components/Search';
import { useDebounce } from 'utils/utils';
import { useGetEvents } from 'hooks/useGetEvents';
import { useTranslation } from 'react-i18next';

const Events: FC = () => {
	const { t } = useTranslation();
	const [selectedOption, setSelectedOption] = useState<FilterOptionType>(FILTER_OPTIONS[2]);
	const [searchQuery, setSearchQuery] = useState<string>('');

	const onChangeSearch = useDebounce(setSearchQuery);

	const onChangeFilter = (option: FilterOptionType) => {
		setSelectedOption(option);
	};

	const { items, isLoading } = useGetEvents({ selectedOption, searchQuery, per_page: 10 });

	const hasEvents = Boolean(items);
	return (
		<Wrapper>
			<Title element="h2">{t('events')}</Title>

			<Container>
				<Search width="300px" onChange={(e) => onChangeSearch(e.target.value)} placeholder={t('events-search')} />
				<LocalFilter onChange={onChangeFilter} options={FILTER_OPTIONS} selectedOption={selectedOption} />
			</Container>

			<EventsDivider />

			<EventsContainer>
				{isLoading ? (
					<LazyLoader height="90vh" margin="96px 0 0 0" />
				) : (
					<>
						<CreateEvent hasEvents={hasEvents} />
						{items?.map(Event)}
					</>
				)}
			</EventsContainer>
		</Wrapper>
	);
};

export { Events };
